import {
  ApiBlobGetRequest,
  ApiGetRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Report - Repair Container',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - Repair Container',
        href: '/adm/opr/report/repair-container',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_wo_detail',
    sortDesc: true,
    fields: [
      {
        key: 'code_wo',
        label: 'WO No',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'WO Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: false,
      },
      {
        key: 'begin_repair',
        label: 'Start',
        sortable: false,
      },
      {
        key: 'complete_repair',
        label: 'End',
        sortable: false,
      },
      {
        key: 'vendor_name',
        label: 'Vendor',
        sortable: false,
      },
      {
        key: 'app_status',
        label: 'Status',
        sortable: false,
      },
    ],
    detail: false,
    form: {
      id_principle: '',
      principle_code: '',
      principle_name: '',
      id_consignee: '',
      consignee_code: '',
      consignee_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportContRepairPTI(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getRepairPTI({ commit, state }) {
    commit('reportContRepairPTI', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      start_date: data.form.date ? data.form.date[0] : '',
      end_date: data.form.date ? data.form.date[1] : '',
    };

    let result = await ApiGetRequest(`opr/report/pti-repair`, params);
    commit('reportContRepairPTI', {
      items: result.data.object || [],
      total: result.data.total || 0,
      loading: false,
    });

    return true;
  },

  async getExportRepairPTI({ commit, state }) {
    commit('reportContRepairPTI', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      start_date: data.form.date ? data.form.date[0] : '',
      end_date: data.form.date ? data.form.date[1] : '',
    };

    let result = await ApiBlobGetRequest(`opr/report/pti-repair`, params);
    commit('reportContPti', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_container_pti_repair.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },
};
